module.exports = __webpack_public_path__ + "img/info_icon5.bce3eac7.png";